import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[luiLink]',
  standalone: true,
})
export class LinkDirective {
  @HostBinding('class') hostClass = 'lui-link';
  @HostBinding('class.lui-link-primary') get primaryClass() {
    return this.primary;
  }
  @Input() primary = false;
}
